/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./MakePermanentDialog.vue?vue&type=template&id=e2584c9e&scoped=true"
import script from "./MakePermanentDialog.vue?vue&type=script&lang=js"
export * from "./MakePermanentDialog.vue?vue&type=script&lang=js"
import style0 from "./MakePermanentDialog.vue?vue&type=style&index=0&id=e2584c9e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2584c9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2584c9e')) {
      api.createRecord('e2584c9e', component.options)
    } else {
      api.reload('e2584c9e', component.options)
    }
    module.hot.accept("./MakePermanentDialog.vue?vue&type=template&id=e2584c9e&scoped=true", function () {
      api.rerender('e2584c9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patient-reassignment/MakePermanentDialog.vue"
export default component.exports